export default __webpack_public_path__ + "e6f60199381b3b262192e0c79a0b6354.png";